import { getLwaAuthorizeUrl } from '../utils/storage-utils';
import logger from '../../logger';
import BaseCustomizer from './base';
import { isPrimaryAuthController } from '../utils/widget-facade';
import { removeMarketingLayout, removeMarketingFailoverLayout } from '../utils/layout-utils';

const hideTitleLogo = () => {
  jQueryCourage('.okta-sign-in-header h1').hide();
};

const removeBrandingForIDPLogin = () => {
  try {
    const authorizeUrl = getLwaAuthorizeUrl();
    const appType = global.settings?.appType;
    if (authorizeUrl && appType === 'patient') {
      const parsedUrl = new URL(authorizeUrl);
      const queryParams = parsedUrl.searchParams;
      const idp = queryParams.get('idp');
      if (idp) {
        hideTitleLogo();
      }
    }
  }
  catch (err) {
    logger.log('Failed while removing branding for IDP Login', err);
  }
};

let originalIdxProceed: (args: any) => Promise<any>;

export default class CommonCustomizer extends BaseCustomizer {
  async shouldCustomize() {
    return true;
  }

  async customize() {
    this.backupOrRestoreIdxProceed();
    removeBrandingForIDPLogin();
    this.removePrimaryAuthCustomizations();
  }

  /**
   * Caches the authClient.idx.proceed function if it has not been cached yet or
   * restores the original function if it has been cached before.
   *
   * This is necessary because we monkey patch the authClient.idx.proceed function in
   * some of the controllers and reuse same instance of authClient across controllers,
   * so we need to restore the original function after each controller finishes.
   */
  private backupOrRestoreIdxProceed() {
    const authClient = this.oktaSignIn.authClient;
    if (!originalIdxProceed) {
      originalIdxProceed = authClient.idx.proceed.bind(authClient);
    }
    else {
      authClient.idx.proceed = originalIdxProceed;
    }
  }

  private removePrimaryAuthCustomizations() {
    if (!isPrimaryAuthController(this.context?.controller)) {
      removeMarketingLayout();
      removeMarketingFailoverLayout();
      jQueryCourage('#athena-marketing').remove();
      jQueryCourage('#athena-copyright').remove();
    }
  }
}

export const testExports = {
  getCachedOriginalIdxProceed: () => originalIdxProceed,
};
